module.exports = __webpack_public_path__ + "img/图像 10@2x.fad10909.webp";